import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import BannerOne from "../components/BannerOne";
import FeatureOne from "../components/FeatureOne";
import FlashSalesOne from "../components/FlashSalesOne";
import BrandOne from "../components/BrandOne";
import NewArrivalOne from "../components/NewArrivalOne";
import ShippingOne from "../components/ShippingOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";

import TopProductSalesOne from "../components/TopProductSalesOne";
import TopProductSalesTwo from "../components/TopProductSalesTwo";
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";



const HomePageOne = () => {
  const navigate = useNavigate();

  return (

    <>

      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}

      <ScrollToTop smooth color="#299E60" />


      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderOne />

      {/* BannerOne */}
      <BannerOne />

      {/* FeatureOne */}

      <FeatureOne />

     

      {/* FlashSalesOne */}
      {/* <FlashSalesOne /> */}


      {/* 50%sales */}
       <TopProductSalesOne /> 

       <section className="banner">
        <div className="container-fluid p-0">
          <div className="banner-slide">
            <Link to="/search/pasta" style={{ position: "relative", zIndex: 9999 }}>
            <img
              // src="/assets/images/banners/mainbanner.jpg"
              src="/assets/images/banners/ak66.png"
              alt="Banner 1"
              className="img-fluid w-100 banner-img maindd"
            />
            </Link>
          </div>
        </div>
       </section>

       {/* 30%sales */}
       <TopProductSalesTwo /> 

    

      {/* BrandOne */}
      <BrandOne />


<section className="banner">
      <div className="container-fluid m-3">
        <div
          className="banner-slide"
          style={{
            cursor: "pointer",
            position: "relative",
            zIndex: 2
          }}
          onClick={() =>
            navigate("/shop/Grocery/Dry Fruits & Nuts/8")
          }
        >
          <img
            src="/assets/images/banners/ak77.png"
            alt="Banner 1"
            className="img-fluid w-100 banner-img maindd"
          />
        </div>
      </div>
    </section>

      {/* NewArrivalOne */}
      <NewArrivalOne />
      

      {/* ShippingOne */}
      {/* <ShippingOne /> */}


      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </> 
  );
};

export default HomePageOne;
